module.exports = __webpack_public_path__ + "static/media/chaticon.4e98a75a.svg";